export * from "./trip-detail.component";
